// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3j8KI","title":"Header_title__2EOr7","left":"Header_left__1YLBf","clinicName":"Header_clinicName__f9nBh"};